// extracted by mini-css-extract-plugin
module.exports = {"form":"SubscribeForm_form__1DaFL","field":"SubscribeForm_field__13zF_","input":"SubscribeForm_input__35a6X","submitButton":"SubscribeForm_submitButton__1S5b_"};